<template>
  <label
    class="block text-sm font-medium text-gray-300 mb-2"
    :for="props.for"
  >
    <slot v-if="!props.label" />
    <span v-else>{{ props.label }}</span>
  </label>
</template>

<script setup lang="ts">
interface Props {
  for?: string;
  label?: string;
}

const props = defineProps<Props>();
</script>
